import React, {Component} from 'react';
import SideBar from './sidebar/SideBar';
import Footer from './components/Footer';
import Nav from './Header/Nav';
import python from '../assets/images/python.jpg';
import pythonsvg from '../assets/images/python.svg';
import training7 from '../assets/images/training7.jpg';
import DevelopRequest from './components/DevelopRequest';
import Subscribe from './components/Subscribe';

class DataScience extends Component{
    render(){
        return(
            <div id="App">
            <SideBar />
                <Nav />
            <header className="showcase" style={{height:'80vh', marginTop:'5vh', backgroundImage: `url(${training7})`}}>
			<div className="showcase-content">
                <div></div>
                <div>
				<h1>Be in <span className="alt-col" style={{color:'rgba(226, 155, 24, 0.945)'}}> Demand.</span></h1>
                <p>"Talk is cheap. Show me the code."</p>
                <p>
                &mdash; Linus Torvalds.
                </p>
                </div>
			</div>
		</header>
        <div className="about">
            <div style={{backgroundImage: `url(${python})`, backgroundClip:'border-box', backgroundPosition:'center', backgroundSize:'cover'}}></div>

            <div>
            <h3 className="path">Data Science With Python</h3>
            <img src={pythonsvg} alt="Data science training in abuja" />
            <p> 
                This course will get you started with the basics of python programming language, including reading and manipulating csv files as well as how to
                use the numpy library. It will will also teach you data manipulation and visualization techniques.
            </p>
            <p> 
            By the end of this course, you will be able to take tabular data, clean it, manipulate it, visualize it, and run basic inferential statistical analyses. 
            </p>

            <h3>courses</h3>
            <p>
               Python.
            </p>

            <h3>call anytime</h3>
            <p>07063509602, 07084894979</p>
            <p>info@codeflarelimited.com</p>

            <h3>visit us</h3>
            <p>Suite C3-19 Central Market Plaza, Beside Sledge Resort, Off Byazhin Roundabout, Kubwa, Abuja.</p>
            </div>
        </div>
        <DevelopRequest />
        <Subscribe />
        <Footer />
            </div>
        )
    }
}

export default DataScience;